module.exports = __webpack_public_path__ + "img/modal-back-arrow.79950d59.svg";